import React from 'react'
import telegram_gif from '../../assets/images/telegram_gif.gif'
import telegram_offical_gif from '../../assets/images/telegram_offical_gif.gif'
import domain_gif from '../../assets/images/domain_gif.gif'
import price_money_gif from '../../assets/images/price_money_gif.gif'
import authentication_gif from '../../assets/images/authentication_gif.gif'

const gifData = [
    {
        img_src: telegram_gif,
        link_src: '#',
    },
    {
        img_src: telegram_offical_gif,
        link_src: '#',
    },
    {
        img_src: domain_gif,
        link_src: '#',
    },
    {
        img_src: price_money_gif,
        link_src: '#',
    },
    {
        img_src: authentication_gif,
        link_src: '#',
    }
]
const GifImagesSection = () => {
    return (
        <>
            <div className='pb-[calc(82px_+_5vw)] px-2.5 lg:p-2.5 mx-auto xl:mx-0 '>
                <div className='lg:w-[370px]'>
                    {gifData.map((item, index) => (
                        <a key={index} href={item.link_src} target="_blank"><img src={item.img_src} className='my-[5px] lg:mb-[5px]' /></a>
                    ))}
                </div>
            </div>
        </>
    )
}

export default GifImagesSection